import React, { useEffect, useState } from "react";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { api } from "@/lib/api";
import { formatDate } from "@/lib/constants";
import { Newspaper, ExternalLink } from "lucide-react";

export default function News() {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/news?limit=60").then(({ data }) => setNews(data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const sources = [...new Set(news.map((n) => n.source))];

  return (
    <div className="App bg-background min-h-screen">
      <Navbar />
      <div className="mx-auto max-w-6xl px-6 py-10">
        <p className="label-eyebrow text-accent flex items-center gap-2"><Newspaper size={14} /> News di settore</p>
        <h1 className="font-display font-bold tracking-tight text-3xl md:text-4xl mt-2">Trasporto via terra</h1>
        <p className="text-muted-foreground mt-2 max-w-2xl">Aggregazione automatica quotidiana dagli articoli dei maggiori portali di settore, con citazione della fonte.</p>
        {sources.length > 0 && (
          <div className="flex flex-wrap gap-2 mt-4">
            {sources.map((s) => <span key={s} className="text-xs px-2.5 py-1 bg-muted rounded-sm border border-border font-mono-plex">{s}</span>)}
          </div>
        )}

        {loading && <p className="text-muted-foreground mt-10">Caricamento articoli…</p>}

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 mt-8">
          {news.map((a) => (
            <a key={a.article_id} href={a.link} target="_blank" rel="noreferrer" data-testid="news-card"
              className="group flex flex-col border border-border rounded-sm bg-card overflow-hidden hover:border-primary transition-colors">
              {a.image && <div className="h-40 overflow-hidden"><img src={a.image} alt="" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" onError={(e) => { e.target.parentElement.style.display = "none"; }} /></div>}
              <div className="p-5 flex-1 flex flex-col">
                <div className="flex items-center justify-between">
                  <span className="label-eyebrow text-accent">{a.source}</span>
                  <span className="text-xs text-muted-foreground">{formatDate(a.published_at)}</span>
                </div>
                <h3 className="font-display font-semibold mt-3 line-clamp-3 flex-1">{a.title}</h3>
                {a.summary && <p className="text-sm text-muted-foreground mt-2 line-clamp-3">{a.summary}</p>}
                <span className="text-xs text-primary mt-3 flex items-center gap-1">Leggi su {a.source} <ExternalLink size={12} /></span>
              </div>
            </a>
          ))}
        </div>

        {!loading && news.length === 0 && <p className="text-muted-foreground mt-10">Nessun articolo disponibile al momento.</p>}
      </div>
      <Footer />
    </div>
  );
}
